export const baseUrls = {
    plat: {
        dev: '//deveimapi.guazi-cloud.com/eim-wfl-common-form',
        test: process.env.NODE_ENV === 'mock' ? `//${document.domain}:9000` : '//testeimapi.guazi-cloud.com/eim-wfl-common-form',
        uat: '//uateimapi.guazi-cloud.com/eim-wfl-common-form',
        online: '//eimapi.guazi.com/eim-wfl-common-form',
    },
    platbase: {
        dev: '//deveimapi.guazi-cloud.com',
        test: process.env.NODE_ENV === 'mock' ? `//${document.domain}:9000` : '//testeimapi.guazi-cloud.com',
        uat: '//uateimapi.guazi-cloud.com',
        online: '//eimapi.guazi.com',
    },
    eim: {
        dev: '//deveimapi.guazi-cloud.com/portal',
        test: process.env.NODE_ENV === 'mock' ? `//${document.domain}:9000` : '//testeimapi.guazi-cloud.com/portal',
        uat: '//uateimapi.guazi-cloud.com/portal',
        online: '//eimapi.guazi.com/portal',
    },
    // runner 用于问卷答题
    runner: {
        dev: '//deveimapi.guazi-cloud.com/eim-wfl-form',
        test: process.env.NODE_ENV === 'mock' ? `//${document.domain}:9000` : '//testeimapi.guazi-cloud.com/eim-wfl-form',
        uat: '//uateimapi.guazi-cloud.com/eim-wfl-form',
        online: '//eimapi.guazi.com/eim-wfl-form',
    },
    ws: {
        dev: '//10.16.208.205:10096',
        test: '//10.16.208.205:10096',
        uat: '//10.16.208.205:10096',
        online: '//ws-work-approve.guazi.com',
    },
    ehrib: {
        dev: '//nehrdev.guazi-corp.com:8000',
        test: '//nehrtst.guazi-corp.com:8000',
        uat: '//nehruat.guazi-corp.com:80',
        online: '//ehrib.guazi-corp.com',
    },
}
